(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function syncAccordions() {
    var nodes = document.querySelectorAll('[data-isf-footer-acc]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].open = !mq.matches;
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    syncAccordions();
    if (mq.addEventListener) mq.addEventListener('change', syncAccordions);
    else if (mq.addListener) mq.addListener(syncAccordions);
  });

  // Third-party floating widgets (Shopify Inbox chat launcher, Ali Reviews'
  // floating tab + rating-notification popup) are all fixed to a bottom
  // corner regardless of scroll position, so they land on top of the
  // newsletter input / help card whenever a visitor scrolls to the footer.
  // Nudge/hide them only while that specific footer zone is on screen, so
  // their normal position elsewhere on the site (e.g. product pages) is
  // untouched.
  onReady(function () {
    var targets = document.querySelectorAll(
      '.isf-footer__col--customer_shopify, .isf-footer__help'
    );
    if (!targets.length || !('IntersectionObserver' in window)) return;

    var visible = typeof Set !== 'undefined' ? new Set() : null;
    var visibleFallback = [];
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (visible) {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          } else {
            var idx = visibleFallback.indexOf(entry.target);
            if (entry.isIntersecting && idx === -1) visibleFallback.push(entry.target);
            else if (!entry.isIntersecting && idx !== -1) visibleFallback.splice(idx, 1);
          }
        });
        var anyVisible = visible ? visible.size > 0 : visibleFallback.length > 0;
        document.body.classList.toggle('isf-footer-widgets-clear', anyVisible);
      },
      { threshold: 0.15 }
    );
    targets.forEach(function (el) {
      observer.observe(el);
    });
  });

  // Inbox paints the bubble icon white on a light pill, so it disappears.
  // Force the SVG to black and leave the rest of the widget untouched.
  onReady(function () {
    function paintChatIcon() {
      var host = document.querySelector('shopify-chat');
      var root = host && host.shadowRoot;
      if (!root) return false;
      var svgs = root.querySelectorAll('[part="activator"] svg, .activator__icon svg, .activator svg');
      var i;
      for (i = 0; i < svgs.length; i++) {
        svgs[i].style.setProperty('color', '#000000', 'important');
        svgs[i].style.setProperty('fill', '#000000', 'important');
        svgs[i].setAttribute('fill', '#000000');
        svgs[i].setAttribute('stroke', '#000000');
      }
      var paths = root.querySelectorAll('[part="activator"] svg *, .activator__icon svg *, .activator svg *');
      for (i = 0; i < paths.length; i++) {
        paths[i].style.setProperty('fill', '#000000', 'important');
        paths[i].style.setProperty('stroke', '#000000', 'important');
        paths[i].setAttribute('fill', '#000000');
        if (paths[i].hasAttribute('stroke') && paths[i].getAttribute('stroke') !== 'none') {
          paths[i].setAttribute('stroke', '#000000');
        }
      }
      return svgs.length > 0;
    }

    if (paintChatIcon()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (paintChatIcon() || tries > 40) window.clearInterval(timer);
    }, 250);
  });
})();
